module.exports = __webpack_public_path__ + "img/48_9.7d4f0437.png";